import { enableProdMode } from '@angular/core';
import { LicenseManager } from 'ag-grid-enterprise';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

LicenseManager.setLicenseKey(environment.AG_GRID_LICENSE);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
